import React, { useState } from "react";
import styled, { keyframes } from "styled-components";
import Navbar from "../component/Header.js/Navbar/Navbar";
import Footer from "../component/Footer/Footer";
import { colors } from "../data";
import CompLoader from "../component/Loaders/CompLoader/CompLoader";
import { useNavigate } from "react-router-dom";
import { Alert, Snackbar, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";

const OuterBox = styled.div`
  background-color: #f7f7f7;
  height: 93vh;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MainBox = styled.div`
  background-color: white;
  width: 60vw;
  box-shadow: 0.1rem 0.1rem 2rem rgba(161, 161, 161, 0.28);
  border-radius: 0.8rem;
  overflow: hidden;
  height: fit-content;
  display: grid;
  grid-template-columns: 1.5fr 2fr;

  @media only screen and (max-width: 700px) {
    grid-template-columns: 1fr;
    width: 90vw;
  }
`;

const LeftDivAni = keyframes`
    0%{  transform: translateX(100%);
        z-index: 100;
        opacity: 0;
    }
    100%{
        transform: translateX(0);
        opacity: 1; z-index: 1;
    }
`;

const RightDivAni = keyframes`
    0%{    transform: translateX(-50%);
        z-index: -1;
        opacity: 0;
    }
    30%{
        z-index: -1;
    }
    100%{
        transform: translateX(0);
        opacity: 1;
        z-index: 1;
    }
`;

const LeftDiv = styled.div`
  background: #511d00;
  background: linear-gradient(
    126deg,
    rgba(81, 29, 0, 1) 0%,
    rgba(81, 29, 0, 1) 45%,
    rgba(81, 29, 0, 0.8) 100%
  );
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 3rem;
  color: white;
  padding: 0 4rem;
  transition: all 1s;
  animation: ${LeftDivAni} 0.6s;
  word-wrap: break-word;
  h1 {
    letter-spacing: 0.09rem;
    font-weight: bold;
  }
  p {
    font-size: 1.6rem;
    font-size: 400;
    letter-spacing: 0.09rem;
    text-align: center;
  }
  button {
    background-color: transparent;
    margin: 0 auto;
    border: 1px solid white;
    border-radius: 2rem;
    padding: 1rem 5rem;
    font-size: 1.7rem;
    text-transform: uppercase;
    letter-spacing: 0.1rem;
    font-weight: bold;
    cursor: pointer;
  }
  @media only screen and (max-width: 700px) {
    padding: 2rem 1rem;
    gap: 1rem;
    h1 {
      font-size: 3rem;
    }
    p {
      font-size: 1.4rem;
    }
    button {
      padding: 1rem 3rem;
      font-size: 1.4rem;
    }
  }
`;

const RightDiv = styled.div`
  margin: 1rem 0;
  height: fit-content;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  animation: ${RightDivAni} 0.6s;
  padding: 4rem;
  h2 {
    font-size: 3.2rem;
  }
  @media only screen and (max-width: 700px) {
    padding: 2rem;
  }
`;

const EmailVerificationBox = styled.div`
  display: flex;
  width: 90%;
  height: fit-content;
  gap: 1rem;
  flex-direction: column;
  align-items: center;
  position: relative;

  p {
    width: 100%;
    color: rgb(221, 57, 57);
    margin-top: -0.5rem;
    letter-spacing: 0.08rem;
    font-size: 1.2rem;
  }
  span {
    cursor: pointer;
  }
`;

const LoaderBox = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  border-radius: 0.6rem;
  z-index: 2;
  background-color: #ebeaea53;
`;

const InputWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
`;

const Input = styled.input`
  width: 100%;
  height: 42px;
  outline: none;
  border: 1px solid rgba(166, 166, 166, 0.3);
  border-radius: 5px;
  padding: 0px 10px;
  padding-right: ${(props) => (props.hasToggle ? "40px" : "10px")};
  transition: all 200ms ease-in-out;
  margin-bottom: 5px;

  &::placeholder {
    color: rgba(200, 200, 200, 1);
  }

  &:focus {
    outline: none;
    border-bottom: 1px solid ${colors.mainColor};
  }
`;

const TogglePasswordButton = styled.button`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  color: #777;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    color: ${colors.mainColor};
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  max-width: 150px;
  padding: 10px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  border: none;
  border-radius: 100px;
  cursor: pointer;
  transition: all 240ms ease-in-out;
  background: linear-gradient(
    58deg,
    ${colors.mainColor} 20%,
    ${colors.mainColor} 100%
  );

  &:hover {
    filter: brightness(1.03);
  }
`;

const DisabledBtn = styled.button`
  width: 100%;
  max-width: 150px;
  padding: 10px;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  border: none;
  border-radius: 100px;
  cursor: pointer;
  transition: all 240ms ease-in-out;
  background: #dbdbdb;

  &:hover {
    filter: brightness(1.03);
  }
`;

const Register = () => {
  const [emailVer] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [emailErr, setEmailErr] = useState(false);
  const [nameErr, setNameErr] = useState(false);
  const [mobileErr, setMobileErr] = useState(false);
  const [passwordErr, setPasswordErr] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [allValid, setAllValid] = useState(false);
  const [serverErr, setServerErr] = useState(false);
  const [serverTxt, setServerTxt] = useState("");
  const navigate = useNavigate();

  const [state, setState] = React.useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const { vertical, horizontal, open } = state;

  const handleClose = () => {
    setState({ ...state, open: false });
  };

  const defaultFields = {
    fullName: "",
    email: "",
    password: "",
    contactNum: "",
  };
  const [inpFields, setInpFields] = useState(defaultFields);

  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
  };

  const checkValidity = (fields) => {
    const { fullName, email, contactNum, password } = fields;
    const isValid =
      fullName.trim().length >= 2 &&
      validateEmail(email) &&
      contactNum.trim().length === 10 &&
      password.trim().length >= 6;
    setAllValid(isValid);
  };

  const onBlurHandler = (e) => {
    const id = e.target.id;
    const val = inpFields[id] || "";
    if (id === "fullName" && val.trim().length < 2) {
      setNameErr(true);
    }
    if (id === "email" && !validateEmail(val)) {
      setEmailErr(true);
    }
    if (id === "contactNum" && val.trim().length !== 10) {
      setMobileErr(true);
    }
    if (id === "password" && val.trim().length < 6) {
      setPasswordErr(true);
    }
  };

  const onChangeHandler = (e) => {
    const id = e.target.id;
    const val = e.target.value;
    const updated = { ...inpFields, [id]: val };
    setInpFields(updated);
    checkValidity(updated);

    if (id === "fullName") setNameErr(false);
    if (id === "email") {
      setServerErr(false);
      setServerTxt("");
      setEmailErr(false);
    }
    if (id === "contactNum") setMobileErr(false);
    if (id === "password") setPasswordErr(false);
  };

  const onSubmitHandler = async (e) => {
    if (e) e.preventDefault();
    if (!allValid) return;

    setIsLoading(true);
    setServerErr(false);
    setServerTxt("");

    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/user/signup`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: inpFields.fullName.trim(),
          email: inpFields.email.trim(),
          password: inpFields.password,
          contactNum: inpFields.contactNum.trim(),
        }),
      });

      const resData = await res.json();
      if (!res.ok) {
        setServerErr(true);
        setServerTxt(resData.message || "Failed to create account. Please try again.");
      } else if (resData.success) {
        setState({ ...state, open: true });
        setTimeout(() => {
          navigate("/login");
        }, 1200);
      }
    } catch (err) {
      console.error("Signup error:", err);
      setServerErr(true);
      setServerTxt("Connection error. Please check your internet connection.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <Snackbar
        open={open}
        anchorOrigin={{ vertical, horizontal }}
        autoHideDuration={6000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity="success"
          variant="filled"
          sx={{ width: "100%", top: 0, fontSize: "1.6rem" }}
        >
          Sign up successful! Redirecting to login...
        </Alert>
      </Snackbar>
      <OuterBox>
        <MainBox>
          <LeftDiv>
            <h1>Welcome Back!</h1>
            <p>
              To keep connected with us please login with your personal info.
            </p>
            <button
              onClick={() => {
                navigate("/login");
              }}
            >
              Sign In
            </button>
          </LeftDiv>
          <RightDiv>
            <h2>Create Account</h2>
            {emailVer && (
              <EmailVerificationBox>
                {isLoading && (
                  <LoaderBox>
                    <CompLoader />
                  </LoaderBox>
                )}
                <Input
                  type="text"
                  name="fullName"
                  id="fullName"
                  className="inputField"
                  placeholder="Full Name"
                  onChange={onChangeHandler}
                  value={inpFields.fullName}
                  onBlur={onBlurHandler}
                  style={{
                    border: `${
                      nameErr
                        ? "1px solid #d72020"
                        : "1px solid rgba(166, 166, 166, 0.3)"
                    }`,
                  }}
                />
                {nameErr && <p>Name must be at least 2 characters</p>}
                <Input
                  type="email"
                  className="inputField"
                  name="email"
                  id="email"
                  onChange={onChangeHandler}
                  placeholder="Email"
                  onBlur={onBlurHandler}
                  value={inpFields.email}
                  style={{
                    border: `${
                      emailErr
                        ? "1px solid #d72020"
                        : "1px solid rgba(166, 166, 166, 0.3)"
                    }`,
                  }}
                />
                {emailErr && <p>Please enter a valid email address</p>}
                <Input
                  type="number"
                  name="contactNum"
                  className="inputField"
                  id="contactNum"
                  onBlur={onBlurHandler}
                  onChange={onChangeHandler}
                  placeholder="10-digit Mobile number"
                  value={inpFields.contactNum}
                  style={{
                    border: `${
                      mobileErr
                        ? "1px solid #d72020"
                        : "1px solid rgba(166, 166, 166, 0.3)"
                    }`,
                  }}
                />
                {mobileErr && <p>Please enter a valid 10-digit mobile number</p>}
                <InputWrapper>
                  <Input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    className="inputField"
                    id="password"
                    hasToggle
                    onBlur={onBlurHandler}
                    value={inpFields.password}
                    onChange={onChangeHandler}
                    placeholder="Password (minimum 6 characters)"
                    style={{
                      border: `${
                        passwordErr
                          ? "1px solid #d72020"
                          : "1px solid rgba(166, 166, 166, 0.3)"
                      }`,
                    }}
                  />
                  <TogglePasswordButton
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    title={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? (
                      <VisibilityOff style={{ fontSize: "1.8rem" }} />
                    ) : (
                      <Visibility style={{ fontSize: "1.8rem" }} />
                    )}
                  </TogglePasswordButton>
                </InputWrapper>
                {passwordErr && (
                  <p>Password must be at least 6 characters</p>
                )}
                {serverErr && <p>{serverTxt}</p>}

                {allValid ? (
                  <SubmitButton onClick={onSubmitHandler}>Submit</SubmitButton>
                ) : (
                  <DisabledBtn>Submit</DisabledBtn>
                )}
              </EmailVerificationBox>
            )}
          </RightDiv>
        </MainBox>
      </OuterBox>
      <Footer />
    </>
  );
};

export default Register;
